// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tenant-select{\n    height: 30px;\n    padding: 2px 25px 2px 20px;\n    position: relative;\n    bottom: 7px;\n}\n.tenant.main-nav{\nheight: 40px;\n}\n.tenant img{\n    height: 50px;\n    width: 50px;\n    position: relative;\n    bottom:7px\n}", ""]);
// Exports
module.exports = exports;
